import { render, staticRenderFns } from "./FormRaporttiAsetuksetBase.vue?vue&type=template&id=5f38c233&"
import script from "./FormRaporttiAsetuksetBase.vue?vue&type=script&lang=js&"
export * from "./FormRaporttiAsetuksetBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f38c233')) {
      api.createRecord('5f38c233', component.options)
    } else {
      api.reload('5f38c233', component.options)
    }
    module.hot.accept("./FormRaporttiAsetuksetBase.vue?vue&type=template&id=5f38c233&", function () {
      api.rerender('5f38c233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormRaporttiAsetuksetBase.vue"
export default component.exports